/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React, { Component } from 'react';
import { v4 as uuid } from 'uuid';
import { Table, Checkbox, RadioGroup, Radio } from '@cimpress/react-components';

const labels = ['Interscope', 'Universal'];

const columns = [
  { Header: 'Title', accessor: 'title', sortable: true },
  {
    Header: 'Released',
    accessor: 'released',
    sortable: true,
    Cell: row => <div onClick={() => alert('custom click')}>{row.original.released} [custom onClick]</div>,
  },
  {
    Header: 'Label',
    accessor: 'label',
    filterMethod: (filter, row) => {
      if (filter.value === 'all') {
        return true;
      }
      return row[filter.id] === filter.value;
    },
    /* eslint-disable react/prop-types */
    Filter: ({ filter, onChange }) => (
      <select onChange={e => onChange(e.target.value)} style={{ width: '100%' }} value={filter ? filter.value : 'all'}>
        <option value="all">Show All</option>
        {labels.map(value => (
          <option value={value} key={value}>
            {value}
          </option>
        ))}
      </select>
    ),
    /* eslint-enable react/prop-types */
  },
  {
    Header: 'Chart Position',
    accessor: 'chart',
    className: 'hidden-sm',
    headerClassName: 'hidden-sm',
  },
];

const fakeData = Array(1000)
  .fill(0)
  .map((_, i, arr) => ({
    title: `Album #${i + 1}`,
    released: `July 8, ${1997 + i}`,
    label: labels[i % labels.length],
    chart: arr.length - i,
    id: uuid(),
  }));

export default class TableDemo extends Component {
  state = {
    condensed: false,
    bordered: true,
    hover: true,
    loading: false,
    noData: false,
    useCustomLoadingText: false,
    loadingText: 'Gathering some data for ya...',
    useCustomNoDataText: false,
    noDataText: 'Really nothing here...',
    sortKey: {
      key: 'title',
      desc: false,
    },
    pageSize: null,
    paginationPosition: 'bottomRight',
  };

  toggle = state => {
    this.setState(prevState => ({ [state]: !prevState[state] }));
  };

  onChangeLoadingText = r => {
    this.setState({ loadingText: r.target.value });
  };

  onChangeNoDataText = r => {
    this.setState({ noDataText: r.target.value });
  };

  render() {
    const { condensed, sortKey, bordered, hover, useCustomNoDataText, noData, noDataText } = this.state;

    const sortedData = fakeData.slice();
    sortedData.sort((a, b) => (sortKey.desc ? -1 : 1) * a[sortKey.key].localeCompare(b[sortKey.key]));

    return (
      <div>
        <Checkbox label="isCondensed" checked={this.state.condensed} onChange={() => this.toggle('condensed')} />
        <Checkbox label="hasHover" checked={this.state.hover} onChange={() => this.toggle('hover')} />
        <Checkbox label="isBordered" checked={this.state.bordered} onChange={() => this.toggle('bordered')} />
        <Checkbox label="noData" checked={this.state.noData} onChange={() => this.toggle('noData')} />
        <RadioGroup
          valueSelected={this.state.pageSize}
          inline
          name="pagesize"
          onChange={(e, v) => this.setState({ pageSize: v })}
        >
          <Radio value={null} label="No pagination" />
          <Radio value={10} label="10 items" />
          <Radio value={20} label="20 items" />
        </RadioGroup>
        <RadioGroup
          valueSelected="bottomRight"
          inline
          name="pos"
          onChange={(e, v) => this.setState({ paginationPosition: v })}
        >
          <Radio value="topRight" label="Top Right" />
          <Radio value="bottomRight" label="Bottom Right" />
        </RadioGroup>
        <div>
          <Checkbox
            label="use custom noDataText"
            checked={this.state.useCustomNoDataText}
            onChange={() => this.toggle('useCustomNoDataText')}
          />
          <input
            type="text"
            className="form-control"
            id="noDataText"
            value={this.state.noDataText}
            disabled={!this.state.useCustomNoDataText}
            onChange={this.onChangeNoDataText}
          />
        </div>
        <br />

        <Table
          columns={columns}
          data={noData ? [] : sortedData}
          isCondensed={condensed}
          isBordered={bordered}
          hasHover={hover}
          sortedBy={sortKey}
          onSortingRequested={newSortKey => {
            this.setState({ sortKey: newSortKey });
          }}
          noDataText={useCustomNoDataText && noDataText}
          pageSize={this.state.pageSize}
          paginationPosition={this.state.paginationPosition}
        />
      </div>
    );
  }
}
